module.exports = __webpack_public_path__ + "static/power-img3-1@2x-c3176acb104a7b4b23af224d52d3b0ab.png";